/**
 *
 * Please note:
 * This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit this file manually.
 *
 */

@file:Suppress(
    "ArrayInDataClass",
    "EnumEntryName",
    "RemoveRedundantQualifierName",
    "UnusedImport"
)

package org.openapitools.client.models


import kotlinx.serialization.*

/**
 * 
 *
 * @param title 
 * @param color 
 */
@Serializable

data class CategoryItem(

    @SerialName(value = "title") val title: String? = null,

    @SerialName(value = "color") val color: Long = 0L

)

